import script from "./prescriptionPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./prescriptionPayments.vue?vue&type=script&setup=true&lang=js"

import "./prescriptionPayments.vue?vue&type=style&index=0&id=6b013d21&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b013d21"]])

export default __exports__